import {DRVBundGlobals} from '@zs21/drv-bund-common-ilias-utils';
import $ from 'jquery';
import {Button} from "@mui/material";
import FeedbackIcon from '@mui/icons-material/Feedback';
import {useState} from "react";
import styled from "@emotion/styled";
import CustomModal from '../CustomModal';
import {ENV_VARS} from '../envVars';
import FeedbackForm from './FeedbackForm';
import React from 'react';

const StyledCTAContainer = styled('div')({
    textAlign: 'right',
    padding: '2rem',
    '& > button': {
        pointerEvents: 'all',
        fontWeight: 'bold',
        '&, &:hover': {
            boxShadow: 'rgba(0, 0, 0, .5) 0 0 7px 0',
            border: '1px solid rgba(255, 255, 255, .5)'
        },
    },
});

function GlobalFeedback() {
    const searchParams = new URLSearchParams(window.location.search);
    const isLoggedIn = $('ul.il-maincontrols-metabar > li > button > span.il-avatar').length === 1 || DRVBundGlobals.ENV === 'dev';
    const isDashboard = searchParams.get('target') === `cat_${ENV_VARS.DASHBOARD_REF_ID}` || searchParams.get('ref_id') === ENV_VARS.DASHBOARD_REF_ID;
    const displayFeedbackButton = isLoggedIn && !isDashboard;
    const [modalOpen, setModalOpen] = useState(false);
    const [processing, setProcessing] = useState(false);

    const showDialog = () => setModalOpen(true);
    window.openFeedback = showDialog;

    const hideModal = () => {
        setModalOpen(false);
    }

    const onProcessingStarted = () => {
        setProcessing(true);
    }

    const onProcessingCompleted = (error) => {
        setProcessing(false);
        !error && setModalOpen(false);
    }

    return (
        <>
            <CustomModal
                title={'Wie gefällt Ihnen die DRV Bund Lernwelt?'}
                open={modalOpen}
                onClose={hideModal}
                isProcessing={processing}
            >
                <FeedbackForm onProcessingStarted={onProcessingStarted} onProcessingCompleted={onProcessingCompleted}/>
            </CustomModal>
            {displayFeedbackButton && <StyledCTAContainer>
                <Button onClick={showDialog} variant={'contained'} startIcon={<FeedbackIcon color="secondary"/>}>
                    Feedback
                </Button>
            </StyledCTAContainer>}
        </>
    );
}

export default GlobalFeedback;
